import React, { useEffect, useState, useRef } from 'react';
import axiosInstance from '../../../API/axiosInstance';
import { getCurrentVendor } from "../../../Auth/UserServices";
import { over } from 'stompjs';
import SockJS from 'sockjs-client';
import DynamicBreadcrumbs from '../../dynamic_breadcumb/dynamic_breadcrumb'
import './vendorChat.css';
var stompClient = null;

export default function VendorChatApp() {
    const [vendor, setVendor] = useState({});
    const [token, setToken] = useState(null);
    const [messages, setMessages] = useState([]);
    const [userList, setUserList] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [newMessage, setNewMessage] = useState("");
    const [userData, setUserData] = useState({
        senderName: "",
        receiverName: "",
        connected: false,
    });

    const selectedUserRef = useRef(selectedUser);
    useEffect(() => {
        selectedUserRef.current = selectedUser;
    }, [selectedUser]);

    useEffect(() => {
        const fetchTokenAndVendor = async () => {
            const storedToken = localStorage.getItem("token");
            if (storedToken) setToken(storedToken);

            const currVendor = await getCurrentVendor();
            if (currVendor) {
                setUserData(prevData => ({ ...prevData, senderName: currVendor.id }));
                setVendor(currVendor);
            }
        };

        fetchTokenAndVendor();
    }, []);

    const updateUserList = (currentMessages) => {
        const userMap = new Map();
        currentMessages.forEach(msg => {
            const otherUserId = msg.senderName === userData.senderName ? msg.receiverName : msg.senderName;
            const otherUserName = msg.senderName === userData.senderName ? msg.rName : msg.sName;

            if (otherUserId) {
                if (!userMap.has(otherUserId)) {
                    userMap.set(otherUserId, { id: otherUserId, name: otherUserName, unreadCount: 0 });
                }

                if (msg.read === false && msg.senderName === otherUserId) {
                    userMap.get(otherUserId).unreadCount++;
                }
            }
        });
        setUserList(Array.from(userMap.values()));
    };

    const fetchChatMessages = async (vendorId) => {
        try {
            const response = await axiosInstance.get(`/get-messages-for-vendor?receiverName=${vendorId}`, {
                headers: { "Authorization": `Bearer ${token}` }
            });

            if (response.data) {
                const sortedMessages = response.data.sort((a, b) => new Date(a.date) - new Date(b.date));
                setMessages(sortedMessages);
                updateUserList(sortedMessages);
            }
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };

    useEffect(() => {
        if (userData.senderName && token) {
            fetchChatMessages(userData.senderName);
            connect();
        }

        return () => {
            if (stompClient?.connected) {
                stompClient.disconnect(() => console.log("WebSocket disconnected!"));
            }
        };
    }, [userData.senderName, token]);

    const markMessagesAsRead = (userId) => {
        const messageIdsToUpdate = messages
            .filter(msg => msg.senderName === userId && msg.receiverName === userData.senderName && !msg.isRead)
            .map(msg => msg.id);

        if (messageIdsToUpdate.length > 0 && stompClient?.connected) {
            stompClient.send("/app/mark-as-read", {}, JSON.stringify({ messageIds: messageIdsToUpdate }));

            const updatedMessages = messages.map(msg =>
                messageIdsToUpdate.includes(msg.id) ? { ...msg, isRead: true } : msg
            );
            setMessages(updatedMessages);
            updateUserList(updatedMessages);
        }
    };

    const handleUserClick = (user) => {
        setSelectedUser(user);
        markMessagesAsRead(user.id);
    };

    const connect = () => {
        let Sock = new SockJS(`https://wedstra-backend-9886.onrender.com/ws`);
        // let Sock = new SockJS('http://localhost:8443/ws');
        stompClient = over(Sock);
        stompClient.connect({}, () => onConnected(userData.senderName), onError);
    };

    const onConnected = (vendorId) => {
        setUserData(prev => ({ ...prev, connected: true }));
        if (stompClient?.connected) {
            stompClient.subscribe(`/user/${vendorId}/private`, onPrivateMessage);
            stompClient.subscribe(`/user/${vendorId}/queue/messages-read`, onMessagesRead);
        }
    };

    const onMessagesRead = (payload) => {
        const { messageIds } = JSON.parse(payload.body);
        // **AND HERE**
        setMessages(prev => prev.map(msg => messageIds.includes(msg.id) ? { ...msg, isRead: true } : msg));
    };

    const onPrivateMessage = (payload) => {
        const newMsg = JSON.parse(payload.body);
        if (newMsg.senderName === userData.senderName) {
            return;
        }

        setMessages(prevMessages => {
            const updatedMessages = [...prevMessages, newMsg];
            updateUserList(updatedMessages);

            if (selectedUserRef.current && selectedUserRef.current.id === newMsg.senderName) {
                // **AND HERE**
                const messageIdToUpdate = [newMsg.id];
                stompClient.send("/app/mark-as-read", {}, JSON.stringify({ messageIds: messageIdToUpdate }));
                return updatedMessages.map(m => m.id === newMsg.id ? { ...m, isRead: true } : m);
            }

            return updatedMessages;
        });
    };

    const onError = (err) => console.log("WebSocket Error:", err);

    const handleMessageChange = (event) => {
        setNewMessage(event.target.value);
    };

    const sendPrivateValue = () => {
        if (stompClient?.connected && newMessage.trim() !== "" && selectedUser) {
            const chatMessage = {
                senderName: userData.senderName,
                sName: vendor.businessName,
                receiverName: selectedUser.id,
                rName: selectedUser.name,
                message: newMessage,
                date: new Date().toISOString(),
                status: "MESSAGE",
                isRead: false
            };

            stompClient.send("/app/private-message", {}, JSON.stringify(chatMessage));
            setMessages(prevMessages => [...prevMessages, chatMessage]);
            setNewMessage("");
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            sendPrivateValue();
        }
    };

    return (
        <section className='main-container'>
            <div className='container my-3'>
                <DynamicBreadcrumbs/>
                <div className="d-flex border" style={{ height: '80vh', borderRadius:"16px" }}>
                    <div className="w-30 border-end p-3 bg-light" style={{ minWidth: '200px', overflowY: 'auto', borderRadius:"16px" }}>
                        <h2>Users</h2>
                        {userList.length === 0 && <div className="text-muted fst-italic">— no conversations yet —</div>}
                        <ul className="list-unstyled">
                            {userList.map(u => (
                                <li key={u.id}
                                    id='user-name'
                                    onClick={() => handleUserClick(u)}
                                    className={`d-flex justify-content-between align-items-center p-2 rounded mb-2 ${selectedUser?.id === u.id ? 'bg-secondary text-white' : ''}`}
                                    style={{ cursor: 'pointer' }}>
                                    <span>{u.name || '...'}</span>
                                    {u.unreadCount > 0 && <span className="badge bg-danger rounded-pill">{u.unreadCount}</span>}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex-grow-1 p-3 d-flex flex-column" id='chat-container'>
                        {selectedUser ? (
                            <>
                                <h4>Chat with <span className='text-primary'>{selectedUser.name}</span></h4>
                                <div className="flex-grow-1 overflow-auto border p-3 rounded" style={{ minHeight: '60vh' }}>
                                    {messages
                                        .filter(msg => msg.senderName === selectedUser.id || msg.receiverName === selectedUser.id)
                                        .map((msg, index) => (
                                            // **AND HERE**
                                            <div key={msg.id || `optimistic-${index}`}
                                                className={`d-flex flex-column ${msg.senderName === userData.senderName ? 'align-items-end' : 'align-items-start'} mb-2`}>
                                                <div className={`p-2 rounded ${msg.senderName === userData.senderName ? 'bg-danger text-white' : 'bg-light text-dark'}`} style={{ maxWidth: '70%' }}>
                                                    {msg.message}
                                                </div>
                                                {msg.senderName === userData.senderName && (
                                                    <div className="text-muted small mt-1">
                                                        {msg.isRead ? 'Read ✓✓' : 'Sent ✓'}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                </div>
                                <div className="d-flex mt-3">
                                    <input
                                        type="text"
                                        value={newMessage}
                                        onChange={handleMessageChange}
                                        placeholder="Type a message..."
                                        onKeyDown={handleKeyPress}
                                        className="form-control"
                                    />
                                    <button className="btn btn-success ms-2" onClick={sendPrivateValue}>Send</button>
                                </div>
                            </>
                        ) : (
                            <div className="d-flex align-items-center justify-content-center h-100">
                                <h4 className="text-muted">Select a user to start chatting</h4>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}